import { getUrlParams } from 'utils';

export const ENV = (process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENV || 'production').trim();
export const BUILD_NUMBER = (process.env.REACT_APP_BUILD_NUMBER || '').trim();
export const BUILD_DATE = (process.env.REACT_APP_BUILD_DATE || '').trim();
export const BRANCH_NAME = (process.env.REACT_APP_BRANCH_NAME || '').trim();

export const SENTRY_KEY = (process.env.REACT_APP_SENTRY_KEY || '').trim();

export const API_BASE_URL_FORUM = (process.env.REACT_APP_API_BASE_URL_FORUM || '').trim();
export const FABRICA_BASE_URL = (process.env.REACT_APP_FABRICA_BASE_URL || '').trim();
export const API_SOCKET_URL = (process.env.REACT_APP_API_SOCKET_URL || '').trim();
export const CDN_BASE_URL_LEGACY = (process.env.REACT_APP_CDN_LEGACY_BASE_URL || '').trim();
export const CDN_BASE_URL = (process.env.REACT_APP_CDN_BASE_URL || '').trim();
export const STAGE_SUFFIX = (process.env.REACT_APP_STAGE_SUFFIX || 'invalid').trim();

export const FILEDOWNLOAD_URL = (process.env.FILEDOWNLOAD_URL || '').trim();

export const TOAST_DEFAULT_TIMEOUT = 3000;
export const TOAST_ERROR_TIMEOUT = 15000;

export const IS_DEV = ENV === 'development';
export const IS_PROD = ENV === 'production';
export const IS_HOMOL = !IS_DEV && !IS_PROD;

export const IS_STAGE = ENV === 'stage';

export const COOKIE_DOMAIN = (process.env.REACT_APP_COOKIE_DOMAIN || '').trim();
export const ACCESS_NEGATIVE_STATUS = ['not_released', 'blocked', 'expired', 'must_accept_term'];

export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '';
export const SOCKET_LOGGING = !!process.env.REACT_APP_SOCKET_LOGGING;

export const ACCOUNTS_TOKEN = process.env.REACT_APP_ACCOUNTS_TOKEN || '';

export const DISABLE_REDIRECT = String(process.env.REACT_APP_DISABLE_REDIRECT) === 'true' || false;

export const IS_MOBILE = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
  navigator.userAgent.toLowerCase()
);

const isApp = getUrlParams().app || localStorage.getItem('isApp');
export const IS_APP: boolean = typeof isApp === 'boolean' ? isApp : false;
localStorage.setItem('isApp', IS_APP.toString());

export const NOTIFICATION_CENTER_URL = (process.env.REACT_APP_NOTIFICATION_CENTER_URL || '').trim();
export const NOTIFICATIONS_CENTER_FEATURES = (process.env.REACT_APP_NOTIFICATIONS_FLAG || '').split(',');

const tokenShowcase = localStorage.getItem('26cd6f7bdc9a9f23e348ad61c29bd9578aaa81d9');
export const SHOWCASE_FEATURE = tokenShowcase
  ? tokenShowcase === 'true'
  : String(process.env.REACT_APP_SHOWCASE_FEATURE) === 'true' || false;
export const FEATURE_LIKE = String(process.env.REACT_APP_FEATURE_LIKE) === 'true' || false;

export const SUBDOMAIN_BLACKLIST = (process.env.REACT_APP_SUBDOMAIN_BLACKLIST || '').split(',');

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();
export const API_V4_BASE_URL = (process.env.REACT_APP_API_V4_BASE_URL || '').trim();
export const V2_URL = (process.env.REACT_APP_V2_URL || '').trim();
export const V3_URL = (process.env.REACT_APP_V3_URL || '').trim();
export const TERMS = `https://www.eduzz.com/termos-e-condicoes`;
export const PRIVACY = `https://www.eduzz.com/politica-de-privacidade`;
const HOUSTON_CDN_URL = (process.env.REACT_APP_HOUSTON_CDN_URL || '').trim();

export const NUTROR_LOGO = `${HOUSTON_CDN_URL}/topbar/logos/nutror-colored.svg`;

export const ALLOW_LEGACY_SHOWCASE_SWITCH = process.env.REACT_APP_ALLOW_LEGACY_SHOWCASE_SWITCH === 'true';

export const ACCOUNTS_AMBIENT = process.env.REACT_APP_ACCOUNTS_AMBIENT;
export const FEATURE_CSAT = (process.env.REACT_APP_FEATURE_CSAT || '').trim();
export const RENEWAL_FEATURE = process.env.REACT_APP_RENEWAL_FEATURE.split(',');
